<template>
  <div>
    <router-view />
  </div>
</template>
<script>

export default {
  name: "PostalCodeIndex",
  data () {
    return {}
  },
  created () {

  },
  methods: {
  
  },
}

</script>
